import { Avatar } from "@base-ui/react/avatar"
import React from "react"

import classNames from "classnames"

import "./styles/_text-avatar.scss"

interface TextAvatarProps {
  initials: string
  color?: string
  className?: string
}

function TextAvatarComponent({ initials, color, className }: TextAvatarProps) {
  return (
    <Avatar.Root
      className={classNames("text-avatar", className)}
      style={{ backgroundColor: color }}
      aria-hidden
    >
      <Avatar.Fallback className="text-avatar__text">
        {initials}
      </Avatar.Fallback>
    </Avatar.Root>
  )
}

export const TextAvatar = React.memo(
  TextAvatarComponent
) as typeof TextAvatarComponent
